/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Team_BodyInputs */

const en_platform_team_body = /** @type {(inputs: Platform_Team_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One coach or a whole studio. Everyone keeps their own hours and clients, on one schedule.`)
};

const pl_platform_team_body = /** @type {(inputs: Platform_Team_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeden trener albo całe studio. Każdy ma swoje godziny i podopiecznych, a grafik jest jeden.`)
};

/**
* | output |
* | --- |
* | "One coach or a whole studio. Everyone keeps their own hours and clients, on one schedule." |
*
* @param {Platform_Team_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_team_body = /** @type {((inputs?: Platform_Team_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Team_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_team_body(inputs)
	return en_platform_team_body(inputs)
});